export default "__VITE_ASSET__8F3pgOGL__"